export const EClassNamesCellBorder = {
  DEFAULT_BORDER: 'box-border border border-component ease-in',
  TRANSITION_DURATION: 'transition-colors duration-300',

  BORDER_R: '!border-r-component-item-border',
  BORDER_R_OPACITY: `!border-r-[rgba(163,163,163,0.0)]`,
  BORDER_L: '!border-l-component-item-border',
  BORDER_L_OPACITY: `!border-l-[rgba(163,163,163,0.0)]`,
  BORDER_T: '!border-t-component-item-border',
  BORDER_T_OPACITY: `!border-t-[rgba(163,163,163,0.0)]`,
  BORDER_B: '!border-b-component-item-border',
  BORDER_B_OPACITY: `!border-b-[rgba(163,163,163,0.0)]`,

  BORDER_Y: '!border-y-component-item-border',
  BORDER_X: '!border-x-component-item-border',

  ROUNDED_L: 'rounded-l-2xl',
  ROUNDED_R: 'rounded-r-2xl',
  ROUNDED_T: 'rounded-t-2xl',
  ROUNDED_B: 'rounded-b-2xl',

  ROUNDED_BR: 'rounded-br-2xl',
  ROUNDED_TR: 'rounded-tr-2xl',
  ROUNDED_BL: 'rounded-bl-2xl',
  ROUNDED_TL: 'rounded-tl-2xl',
};
